import { render, staticRenderFns } from "./edutalk-brank.vue?vue&type=template&id=03ccea92&scoped=true"
import script from "./edutalk-brank.vue?vue&type=script&lang=js"
export * from "./edutalk-brank.vue?vue&type=script&lang=js"
import style0 from "./edutalk-brank.vue?vue&type=style&index=0&id=03ccea92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ccea92",
  null
  
)

export default component.exports